"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TableauEvent_1 = require("./TableauEvent");
class TableauSheetEvent extends TableauEvent_1.TableauEvent {
    constructor(type, sheet) {
        super(type);
        this._sheet = sheet;
    }
    get sheet() {
        return this._sheet;
    }
}
exports.TableauSheetEvent = TableauSheetEvent;
//# sourceMappingURL=TableauSheetEvent.js.map